import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

export interface useCreateSupportUserMutationArguments {
  axios: AxiosInstance;
  workshopId: number;
}

async function create({ axios, workshopId }: useCreateSupportUserMutationArguments): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/workshop-user/support`, {
    workshop_id: workshopId,
  });
  return data;
}

export default function useCreateSupportUserMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ workshopId }: Omit<useCreateSupportUserMutationArguments, 'axios'>) => create({ axios, workshopId }),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
